import React from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import CCrud from "components/Molecules/Crud";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import MeritApiLogDetails from "pages/merit/MeritApiLogDetails";

function MeritApiLogsTemplate({
  data,
  count,
  details,
  paginationPage,
  handlePageChange,
  rowData,
  breadcrumbs,
  filterList,
  actionsList,
  setFilterObj,
}) {
  const { t } = useTranslation();

  const columnData = [
    { accessor: "id", Header: t("merit_api_logs.col_id") },
    {
      accessor: "endpoint_display",
      Header: t("merit_api_logs.col_endpoint"),
      sort: true,
    },
    {
      accessor: "method_display",
      Header: t("merit_api_logs.col_method"),
    },
    {
      accessor: "status_code_display",
      Header: t("merit_api_logs.col_status_code"),
    },
    {
      accessor: "result_display",
      Header: t("merit_api_logs.col_result"),
    },
    {
      accessor: "order_reference_display",
      Header: t("merit_api_logs.col_order"),
    },
    {
      accessor: "date",
      Header: t("merit_api_logs.col_date"),
      sort: true,
    },
    { accessor: "Actions", Header: t("merit_api_logs.actions") },
  ];

  return (
    <Box>
      <Stack
        direction="row"
        alignSelf="start"
        justifyContent="start"
        gap={2}
        width="100%"
      >
        <Breadcrumb data={breadcrumbs} />
      </Stack>
      <CCrud
        table={{
          list: data,
          listTitle: t("merit_api_logs.list_title"),
          columns: columnData,
          isSearch: false,
          isChecked: false,
          total_count: count,
          setFilterObj,
          className: "main-table",
          paginationPage,
          handlePageChange,
          rowData,
          filterList,
          actionsList,
          details,
        }}
        DetailsComponent={<MeritApiLogDetails details={details} />}
      />
    </Box>
  );
}

export default MeritApiLogsTemplate;
